import React from "react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CTAButton } from "../components/CTAButton";
import { Check } from "lucide-react";
import { PRODUCTS, IMAGES } from "../data/content";

export default function Products() {
  return (
    <div>
      <PageHero
        testid="products-hero"
        overline="Products"
        title={<>Platforms ready<br />to deploy</>}
        subtitle="Battle-tested products for record books, training data, and eligibility — customizable to your sport, classification, and workflows."
      />

      <section className="py-24 bg-dark">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 space-y-px">
          {PRODUCTS.map((p, i) => {
            const accentText = p.accent === "teal" ? "text-teal" : "text-orange";
            const flip = i % 2 === 1;
            return (
              <Reveal key={p.name}>
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center border-t border-white/15 py-16">
                  <div className={`lg:col-span-6 ${flip ? "lg:order-2" : ""}`}>
                    <div className="flex items-center gap-4 mb-5">
                      <span className={`grid place-items-center w-12 h-12 border border-white/15 ${accentText}`}>
                        <p.icon className="w-6 h-6" strokeWidth={1.5} />
                      </span>
                      <span className="font-mono text-xs uppercase tracking-widest text-slate-400">{p.tagline}</span>
                    </div>
                    <h2 className="font-display text-4xl md:text-6xl font-black uppercase tracking-tighter mb-5">{p.name}</h2>
                    <p className="text-slate-400 text-lg leading-relaxed mb-8 max-w-lg">{p.desc}</p>
                    <div className="grid grid-cols-2 gap-3 mb-8 max-w-lg">
                      {p.features.map((f) => (
                        <div key={f} className="flex items-center gap-2.5 text-sm text-slate-300">
                          <Check className={`w-4 h-4 ${accentText}`} /> {f}
                        </div>
                      ))}
                    </div>
                    <CTAButton to="/contact" variant={p.accent === "teal" ? "teal" : "orange"} data-testid={`product-cta-${p.name.toLowerCase()}`}>
                      Request {p.name} demo
                    </CTAButton>
                  </div>
                  <div className={`lg:col-span-6 ${flip ? "lg:order-1" : ""}`}>
                    <div className="relative">
                      <div className={`absolute -inset-3 border ${p.accent === "teal" ? "border-teal/30" : "border-orange/30"}`} />
                      <img
                        src={i === 1 ? IMAGES.training : IMAGES.dashboard}
                        alt={p.name}
                        className="relative w-full aspect-[4/3] object-cover grayscale-[0.2]"
                      />
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="py-24 bg-dark-surface border-t border-white/10">
        <div className="max-w-4xl mx-auto px-6 text-center flex flex-col items-center">
          <Reveal>
            <h2 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tighter">
              Need something custom?
            </h2>
            <p className="text-slate-400 mt-5 mb-9 max-w-xl">
              Every product is a starting point. We tailor data models, dashboards, and search to fit your exact program.
            </p>
            <CTAButton to="/contact" variant="orange" data-testid="products-custom-cta">Talk to us</CTAButton>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
